// src/environments/environment.ts
export const environment = {
  production: false,
  apiKey: 'AIzaSyBDtSElGfzCvF5jxeUOI8XFXlxrLxemsoQ',
};

export const API = {
  production: false,
  apiUrl: 'https://f8zs9dg622.execute-api.ap-southeast-2.amazonaws.com/',
};
